import { fileManagerSlideoutMenuItemsIds } from '../features/file-manager';
import { useDocumentLibraryTranslations } from './useDocumentLibraryTranslations';
import { useEditDialog } from './useEditDialog';
export const useEditDialogMenuItem = () => {
    const { t } = useDocumentLibraryTranslations();
    const { showEditDialog } = useEditDialog();
    return (params) => {
        return {
            label: t('documentPanel.editDetails'),
            id: fileManagerSlideoutMenuItemsIds.editDetails,
            'data-test': 'edit-details-menu-item',
            onClick: () => showEditDialog({
                file: params.fileColumns,
                fileEntityType: params.fileEntityType,
                onSuccess: () => {
                    params.onEditDetails();
                },
            }),
        };
    };
};
